import { useTranslation } from 'react-i18next'

import { GlobalSettingsIcon } from '@reveni-io/reveni-ui'
import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const GlobalSettingsInUseBanner = () => {
  const { t } = useTranslation()
  return (
    <Styles.Container>
      <Styles.TitleContainer>
        <GlobalSettingsIcon />
        <Text type="titleS">{t('Configuración global')}</Text>
      </Styles.TitleContainer>
      <Text type="bodyMRegular">
        {t(
          'Esta página utiliza la configuración global de tu organización. Para realizar cambios, actualiza esa configuración.'
        )}
      </Text>
    </Styles.Container>
  )
}

export default GlobalSettingsInUseBanner
